import PushManage from '../pages/manage/PushManage.vue';
import PushSend from '../pages/manage/PushSend.vue';
import PushInquiry from '../pages/manage/PushInquiry.vue';
import SplashSubmit from '../pages/manage/SplashSubmit.vue';
import SplashModify from '../pages/manage/SplashModify.vue';
import InitPopupRegister from '../pages/manage/InitPopupRegister';
import InitPopupModify from '../pages/manage/InitPopupModify';
import PlaceholderManage from '../pages/manage/PlaceholderManage.vue';
import SearchDefaultText from '../pages/manage/SearchDefaultText.vue';
import AddSearchDefaultText from '../pages/manage/AddSearchDefaultText.vue';
import SearchLog from '../pages/manage/SearchLog.vue';

export default {
	PushManage: {
		id: 'PushManage',
		title: '푸시 관리',
		heading: '푸시 관리',
		path: '/manage/push-manage',
		component: PushManage,
	},
	PushSend: {
		id: 'PushSend',
		title: '푸시/알림함 전송',
		heading: '푸시/알림함 전송',
		path: '/manage/push-send',
		component: PushSend,
	},
	PushInquiry: {
		id: 'PushInquiry',
		title: '푸시/알림함 조회',
		heading: '푸시/알림함 조회',
		path: '/manage/push-inquiry/:idNoti/:idNotiSchedule',
		component: PushInquiry,
	},
	SplashSubmit: {
		id: 'SplashSubmit',
		title: '스플래시 이미지 등록',
		heading: '스플래시 이미지 등록',
		path: '/manage/splash-submit',
		component: SplashSubmit,
	},
	SplashModify: {
		id: 'SplashModify',
		title: '스플래시 이미지 수정',
		heading: '스플래시 이미지 수정',
		path: '/manage/splash-modify/:splashId',
		component: SplashModify,
	},
	InitPopupRegister: {
		id: 'InitPopupRegister',
		title: '팝업배너 등록',
		heading: '팝업배너 등록',
		path: '/manage/init-popup/register',
		component: InitPopupRegister,
	},
	InitPopupModify: {
		id: 'InitPopupModify',
		title: '팝업배너 수정',
		heading: '팝업배너 수정',
		path: '/manage/init-popup/modify/:idPopup',
		component: InitPopupModify,
	},
	PlaceholderManage: {
		id: 'PlaceholderManage',
		title: '플레이스홀더 관리',
		heading: '플레이스홀더 관리',
		path: '/manage/placeholder-manage',
		component: PlaceholderManage,
	},
	SearchDefaultText: {
		id: 'SearchDefaultText',
		title: '검색 기본 텍스트',
		heading: '검색 기본 텍스트',
		path: '/manage/search-default-text',
		component: SearchDefaultText,
	},
	AddSearchDefaultText: {
		id: 'AddSearchDefaultText',
		title: '검색 기본 텍스트 등록',
		heading: '검색 기본 텍스트 등록',
		path: '/manage/add-search-default-text',
		component: AddSearchDefaultText,
	},
	SearchLog: {
		id: 'SearchLog',
		title: '검색 로그 TOP 10000',
		heading: '검색 로그 TOP 10000',
		path: '/manage/search-log',
		component: SearchLog,
	},
};
